import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-document',
  templateUrl: './main-document.component.html',
  styleUrls: ['./main-document.component.css']
})
export class MainDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
